import React from 'react';

interface TextProps {
  children: React.ReactNode;
  variant?: 'body' | 'heading' | 'special';
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
  className?: string;
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  style?: React.CSSProperties;
}

/**
 * Text component with typography support
 * Uses Space Grotesk for all text (special font to be determined later)
 */
export const Text: React.FC<TextProps> = ({
  children,
  variant = 'body',
  size = 'base',
  weight = 'regular',
  className = '',
  as,
  style,
}) => {
  const fontFamily = 'font-primary'; // Using Space Grotesk for all text
  
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl',
  };

  const weightClasses = {
    regular: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
  };

  const Component = as || (variant === 'heading' ? 'h2' : 'p');

  return (
    <Component
      className={`${fontFamily} ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}
      style={style}
    >
      {children}
    </Component>
  );
};

export default Text;
